import { ShipmentStatusEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function shipmentStatusOptions(): SelectOption<string>[] {
  return [
    ShipmentStatusEnum.shipment_preparing,
    ShipmentStatusEnum.shipment_waiting_for_loading,
    ShipmentStatusEnum.shipment_in_transit,
    ShipmentStatusEnum.shipment_preparing_for_customs,
    ShipmentStatusEnum.shipment_waiting_for_customs,
    ShipmentStatusEnum.shipment_customs_in_process,
    ShipmentStatusEnum.shipment_waiting_for_pickup,
    ShipmentStatusEnum.shipment_in_delivery,
    ShipmentStatusEnum.shipment_arrived,
    ShipmentStatusEnum.shipment_completed,
    ShipmentStatusEnum.shipment_cancelled
  ].map((val: ShipmentStatusEnum) => {
    return { value: val, label: i18n.t(`shipmentStatus.${val}`).toString() };
  });
}

export function defaultShipmentListStatuses(): ShipmentStatusEnum[] {
  const defaultShipmentListStatuses = [];
  const exceptionStatus = [
    ShipmentStatusEnum.shipment_completed,
    ShipmentStatusEnum.shipment_cancelled
  ];

  Object.entries(ShipmentStatusEnum).forEach(([_key, value]) => {
    if (!exceptionStatus.includes(value)) {
      defaultShipmentListStatuses.push(value);
    }
  });
  return defaultShipmentListStatuses;
}
